import { paths } from '@/shared/routing'
import { methods } from '../constants'
import { API_END_POINTS as api_end_points } from '../end-points'

const queryKeys = (
  cb: (api_end_pointsT: typeof api_end_points, methodsT: typeof methods, pathsT: typeof paths) => string[] | string,
) => {
  return cb(api_end_points, methods, paths)
}

export default queryKeys
